export default "__VITE_ASSET__BQsVCNxy__"